<template>
  <div>
    <v-btn class="success"><download-csv v-if="readingDataJSON.length > 0" name="readings.csv" :data="readingDataJSON" :fields="Object.keys(readingDataFormat)" :labels="readingDataFormat">Download Readings</download-csv></v-btn>
    <v-btn class="error"><download-csv v-if="alertDataJSON.length > 0" name="alerts.csv" :data="alertDataJSON" :fields="Object.keys(alertDataFormat)" :labels="alertDataFormat">Download Alerts</download-csv></v-btn>
  </div>
</template>

<script>
export default {
  name: 'DeviceTypeReportCSV',
  props: {
    data: {
      type: Array,
      required: true
    },
    readingsNames: {
      type: Array,
      required: true
    },
    alertsNames: {
      type: Array,
      required: true
    },
    deltas: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      readingDataFormat: null,
      readingDataJSON: null,
      alertDataFormat: null,
      alertDataJSON: null
    }
  },
  methods: {
    generateDeviceJSON (data, readingsNames, alertsNames, deltas) {
      var readingDataJSON = []
      var readingDataFormat = { 'deviceID': 'DeviceID', 'timestamp': 'Timestamp', 'rawData': 'rawData', 'msgType': 'msgType', 'msgSeq': 'msgSeq' }
      var alertDataJSON = []
      var alertDataFormat = { 'deviceID': 'DeviceID', 'timestamp': 'Timestamp', 'rawData': 'rawData', 'msgType': 'msgType', 'msgSeq': 'msgSeq', 'alertID': 'alertID' }

      // Create dictionary of key 'names' from array[] of header strings
      readingsNames.forEach(function (name) {
        readingDataFormat[name] = name
        // If readings data field contains computed deltas
        // ..add these to the headers to be formed into CSV
        if (deltas.hasOwnProperty(name)) {
          readingDataFormat[name + 'delta'] = name + 'delta'
          readingDataFormat[name + 'deltasecs'] = name + 'deltasecs'
          readingDataFormat[name + 'rate'] = name + 'rate'
        }
      })
      alertsNames.forEach(function (name) {
        alertDataFormat[name] = name
      })

      var lastDeviceID = ''
      var currentDeltaIndex = -1
      data.forEach(function (msg) {
        if (msg.decoded_data) {
          // Add standard msg fields to the decoded data.
          // (Saves creating a new object)
          msg.decoded_data.deviceID = `\t${msg.author_devicename}`
          msg.decoded_data.timestamp = msg.timestamp
          msg.decoded_data.rawData = `0x${msg.data}`
          // msgType 1,2: Readings
          // msgType 3: Alert
          if (msg.decoded_data.msgType === 1 || msg.decoded_data.msgType === 2) {
            readingsNames.forEach(function (name) {
              // Pad readings fields not in msg, so length matches header labels
              if (!msg.decoded_data.hasOwnProperty(name)) {
                msg.decoded_data[name] = null
              }
              // If readings data field contains computed deltas
              // ..add these to the dataset to be formed into CSV
              if (deltas.hasOwnProperty(name)) {
                // Add delta properties and set to non-computed -1
                msg.decoded_data[name + 'delta'] = -1
                msg.decoded_data[name + 'deltasecs'] = -1
                msg.decoded_data[name + 'rate'] = -1
                // Search delta array of objects and find delta set with matchhing timestamp
                // ..keep position in array (indexof) incase duplicate timestamps
                var index = deltas[name].findIndex(({ timestamp }, idx) => timestamp === msg.timestamp && idx > currentDeltaIndex)
                // var objDeltaKeyValue = deltas[name].find(({ timestamp }) => timestamp === msg.timestamp)
                // DEBUG - uncomment to see
                // eslint-disable-next-line
                // console.log(currentDeltaIndex, index, lastDeviceID, msg.author_devicename)
                if (index > currentDeltaIndex) {
                  currentDeltaIndex = index
                  var objDeltaKeyValue = deltas[name][index]
                  if (objDeltaKeyValue !== undefined && lastDeviceID.localeCompare(msg.author_devicename) === 0) {
                    // Found next timestamp delta object belonging to same Device
                    msg.decoded_data[name + 'delta'] = objDeltaKeyValue.value
                    msg.decoded_data[name + 'deltasecs'] = objDeltaKeyValue.deltasecs
                    msg.decoded_data[name + 'rate'] = objDeltaKeyValue.rate
                  }
                }
                // If case - doing Export ALL, need to track the messages->deviceID to detect Device record break boundary
                lastDeviceID = msg.author_devicename
              }
            })
            readingDataJSON.push(msg.decoded_data)
          } else if (msg.decoded_data.msgType === 3) {
            alertsNames.forEach(function (name) {
              // Pad alerts fields not in msg, so length matches header labels
              if (!msg.decoded_data.hasOwnProperty(name)) {
                msg.decoded_data[name] = null
              }
            })
            alertDataJSON.push(msg.decoded_data)
          }
        }
      })
      this.readingDataFormat = readingDataFormat
      this.readingDataJSON = readingDataJSON
      this.alertDataFormat = alertDataFormat
      this.alertDataJSON = alertDataJSON
    }
  },
  beforeMount () {
    if (this.data && this.data.length > 0) {
      this.generateDeviceJSON(this.data, this.readingsNames, this.alertsNames, this.deltas)
    } else {
      this.$emit('error', 'No data provided.')
    }
  }
}
</script>
